import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    tabStats: 'Статистика',
    tabReviews: 'Отзывы',
    backToCourses: 'К моим курсам',
    rating: 'Рейтинг',
    reviews: 'Отзывы',
    completedCourse: 'Прошли курс',
    pageNotFound: 'Страница не найдена',
    pageNotFoundHint: 'Возможно, ссылка устарела или в адресе опечатка.',
    backHome: 'Вернуться на главную',
    courseDeleted: 'Курс удалён',
    courseDeleteFailed: 'Не удалось удалить курс',
    invalidCourseId: 'Неверный идентификатор курса',
  },
  en: {
    tabStats: 'Statistics',
    tabReviews: 'Reviews',
    backToCourses: 'Back to my courses',
    rating: 'Rating',
    reviews: 'Reviews',
    completedCourse: 'Completions',
    pageNotFound: 'Page not found',
    pageNotFoundHint: 'The link may be outdated, or there is a typo in the address.',
    backHome: 'Back to home',
    courseDeleted: 'Course deleted',
    courseDeleteFailed: 'Couldn’t delete the course',
    invalidCourseId: 'Invalid course ID',
  },
})
